<div class="select-recipient d-flex flex-column justify-content-between container p-4">
    <div class="d-flex justify-content-start align-items-center cursor-pointer" (click)="cancel()">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        <span>Back</span>
    </div>

    <div class="my-4">
        <h2>Enter receiver's phone number</h2>
        <p>Enter the agent's phone number to top up their wallet.</p>
    </div>

    <div class="phone-number">
        <div class="phone-number-input d-flex align-items-center mt-4">
            <ngx-mat-intl-tel-input
                [enablePlaceholder]="true"
                [enableSearch]="allowedCountriesInPhoneSearch.length === 0"
                [onlyCountries]="allowedCountriesInPhoneSearch"
                [formControl]="mobileControl"
                class="w-100"
                name="mobile"
                searchPlaceholder="Search country.."
            />
        </div>
        <div class="m-2">
            <div *ngIf="mobileControl.hasError('required') && (mobileControl.touched || mobileControl.dirty)" class="error-msg">
                <mat-icon class="errorIcon" fontIcon="error" />
                Phone number is required.
            </div>
            <div *ngIf="mobileControl.hasError('validatePhoneNumber') && (mobileControl.touched || mobileControl.dirty)" class="error-msg">
                <mat-icon class="errorIcon" fontIcon="error" />
                Phone number is invalid.
            </div>
        </div>
    </div>

    <div class="footer d-flex justify-content-start align-items-center mt-4">
        <button
            [class.button-spinner]="loading"
            [class.btn-primary-disabled]="mobileControl.invalid || !mobileControl.dirty"
            [disabled]="mobileControl.invalid || !mobileControl.dirty || loading"
            class="btn-primary rounded-pill me-2"
            mat-raised-button
            (click)="continue()"
        >
            {{ loading ? '' : 'Continue' }}
        </button>
        <button class="btn-secondary rounded-pill" mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</div>
